module.exports = __webpack_public_path__ + "static/img/introduction-icon1.950684cb.png";